import "../../shared/sparkle_namespace.js";

jQuery(function () {
  if (Sparkle.Pagebuilder.active) {
    return;
  }

  function showLightbox(url) {
    jQuery.when().then(function () {
      var lightbox = new Modal({ class: "lightbox-modal", focusInput: false });
      var $body = jQuery("<div></div>").load(url + " article", function (response) {
        lightbox.setBody($body);
        lightbox.show();
      });
    });
  }

  var lightboxMeta = jQuery("meta[property=lightbox]");
  if (lightboxMeta.length) {
    setTimeout(
      function () {
        showLightbox(lightboxMeta.data("url"));
      },
      lightboxMeta.data("delay") * 1000,
    );
  }

  jQuery(document).on("click", "[target=lightbox]", function (event) {
    event.preventDefault();
    showLightbox(jQuery(event.currentTarget).attr("href"));
  });
});
